import { apiClient } from '../../axios';
import { UserPoolEligibilityResponse, UserPoolResponse } from './types';

/**
 * Get current user pool eligibility
 * GET /userpools/eligibility
 */
export const getUserPoolEligibilityApi = () => apiClient.get<UserPoolEligibilityResponse>('/v1/userpools/eligibility');

/**
 * Get user pool details by ID
 * GET /userpools/:id
 * 비로그인도 호출 가능
 */
export const getUserPoolApi = (id: string) => apiClient.get<UserPoolResponse>(`/v1/userpools/${id}`);

/**
 * Join user pool
 * POST /userpools/:id
 *
 * @returns 201 - Success
 * @throws 401 - 비로그인
 * @throws 403 - 참여불가한 사람이 참여하려고 할 때
 * @throws 404 - 올바르지 않은 id인 경우
 */
export const postUserPoolJoinApi = (id: string) => apiClient.post(`/v1/userpools/${id}`);
